import mixpanel from 'mixpanel-browser';

let initialized = false;

const readGlobalCfg = () => (typeof window !== 'undefined' ? window.__VUMEDI_MIXPANEL_CONTEXT__ || {} : {});

const MIN_REPLAY_SAMPLE = 0;
const MAX_REPLAY_SAMPLE = 100;

const init = (cfg) => {
    if (initialized) return;
    const config = cfg || readGlobalCfg();

    if (!config.MIXPANEL_TOKEN) {
        // eslint-disable-next-line no-console
        console.warn('[analytics] MIXPANEL_TOKEN missing; init skipped.');
        return;
    }

    mixpanel.init(config.MIXPANEL_TOKEN, {
        debug: config.MIXPANEL_DEBUG,
        autocapture: config.MIXPANEL_AUTOCAPTURE,
        record_sessions_percent: Math.max(
            MIN_REPLAY_SAMPLE,
            Math.min(MAX_REPLAY_SAMPLE, Number(config.MIXPANEL_REPLAY_SAMPLE) || 0),
        ),
        record_mask_text_selector: '[id^="grp-"], [class*="grp-"]',
        record_block_selector: '[id^="grp-"], [class*="grp-"]',
    });

    initialized = true;

    const props = {
        platform: config.MIXPANEL_PLATFORM,
        env: config.MIXPANEL_ENVIRONMENT_NAME,
    };

    if (config.MIXPANEL_USER_ID) {
        identify(String(config.MIXPANEL_USER_ID));
    }

    mixpanel.register(props);
};

const identify = (userId, traits = {}) => {
    if (!initialized) return;
    if (userId) mixpanel.identify(userId);
    if (traits && Object.keys(traits).length) mixpanel.people?.set(traits);
};

const setOnce = (props = {}) => {
    if (initialized && Object.keys(props).length) mixpanel.people?.set_once(props);
};

const register = (props = {}) => {
    if (initialized && Object.keys(props).length) mixpanel.register(props);
};

const track = (event, props = {}) => {
    if (initialized) mixpanel.track(event, props);
};

const page = (name, props = {}) => {
    const title = typeof document !== 'undefined' && document.title ? document.title : undefined;
    const path = typeof window !== 'undefined' && window.location ? window.location.pathname : undefined;

    track('Page Viewed', { name: name ?? title, path, ...props });
};

const sessionId = () => {
    if (!initialized) return null;
    const props = mixpanel.get_session_recording_properties();
    return props.$mp_replay_id || null;
};

const startReplay = () => mixpanel.start_session_recording?.();
const stopReplay = () => mixpanel.stop_session_recording?.();
const reset = () => mixpanel.reset?.();
const getDistinctId = () => mixpanel.get_distinct_id?.();

const mixpanelAnalytics = {
    init,
    identify,
    setOnce,
    register,
    track,
    page,
    sessionId,
    startReplay,
    stopReplay,
    reset,
    getDistinctId,
};

export default mixpanelAnalytics;
